// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CSpHv","content":"styles_content__3nJQn"};